import ReactGA from 'react-ga4';
import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Context } from '../../../DataStore';

import Marquee from "react-fast-marquee";

import * as strings from '../../../data/strings';
import * as constants from '../../exports/constants';

import '../../../styles/marketing/v2/Hero.scss';

const Hero = (props) => {
	const { store } = useContext(Context);
	const history = useHistory();

	const goLogin = () => {
		if (!constants.services.devMode) {
			ReactGA.event({
				category: "Marketing",
				action: "Login - Header"
			});
		}
		history.push('/login/');
	}

	const goRegister = () => {
		if (!constants.services.devMode) {
			ReactGA.event({
				category: "Marketing",
				action: "Register - Header"
			});
		}
		history.push('/register/');
	}

	const schools = [
		{
			image: 'nwu',
			school: 'Northwestern University'
		},
		{
			image: 'txstate',
			school: 'Texas State University'
		},
		{
			image: 'minnesota',
			school: 'University of Minnesota'
		},
		{
			image: 'suny',
			school: 'State University of New York'
		},
		{
			image: 'rit',
			school: 'Rochester Institute of Technology'
		},
		{
			image: 'ballsu',
			school: 'Ball State University'
		},
		{
			image: 'scsu-2',
			school: 'Southern Connecticut State University'
		},
		{
			image: 'bhsu',
			school: 'Black Hills State University'
		},
		{
			image: 'ecc-sm',
			school: 'ECC'
		},
		{
			image: 'ahisd',
			school: 'Alamo Heights ISD'
		},
		{
			image: 'navasota',
			school: 'Navasota ISD'
		},
		{
			image: 'futures-academy',
			school: 'Futures Academy'
		},
		{
			image: 'big-walnut',
			school: 'Big Walnut Local Schools'
		},
		{
			image: 'brophy',
			school: 'Brophy College Preparatory'
		},
		{
			image: 'evanston',
			school: 'Evanston Township High School'
		},
		{
			image: 'muskego',
			school: 'Muskego Norway Schools'
		}
	]

	return (
		<div className="Hero">
			<div className="menuBar">
				<img
					className="gravityLogo"
					src={`${process.env.REACT_APP_CF_MKT_ENDPOINT}svg/gravity-logo-white.svg`}
					alt="Gravity Logo" />
				<div className="buttonsWrapper">
					<div className="buttonWrapper">
						<button
							className="headerButton startHere"
							onClick={() => goRegister()}>
							{strings.default[store.language].Marketing.StartForFree}
						</button>
					</div>
					<div className="buttonWrapper">
						<button
							className="headerButton logIn"
							onClick={() => goLogin()}>
							{strings.default[store.language].Marketing.LogIn}
						</button>
					</div>
				</div>
			</div>
			<div className="wrapper">
				<div className="content">
					<div className="contentBox left">
						<div className="headerTextWrapper">
							<div className="headerText">
								{strings.default[store.language].Marketing.HeroTitle}
							</div>
							<div className="headerSubtext">
								<span className="bold">{strings.default[store.language].Marketing.HeroDescriptionBold}</span> {strings.default[store.language].Marketing.HeroDescription}
							</div>
						</div>
					</div>
					<div className="contentBox right">
						<img
							className="contentImage"
							src={`${process.env.REACT_APP_CF_MKT_ENDPOINT}png/section-2-thought-graphic.png`}
							alt="Record anything" />
					</div>
				</div>
			</div>
			<div className="logoSlider">
				<Marquee speed="0.5">
					{[0, 0].map(() => (
						schools.map((school, i) => (
							<div
								className="slide"
								key={`School${i}`}>
								<img
									className="logo"
									src={`${process.env.REACT_APP_CF_MKT_ENDPOINT}png/${school.image}.png`}
									alt={school.school} />
							</div>
						))
					))}
				</Marquee>
			</div>
		</div >
	);
}

export default Hero;
